(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'emotion'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('emotion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.emotion);
    global.VerticalNavSection = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _emotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    list-style-type: none;\n    margin-bottom: 0;\n    margin-block-start: 0;\n    margin-block-end: 0;\n    padding-inline-start: 0;\n    padding-left: 0;\n  '], ['\n    list-style-type: none;\n    margin-bottom: 0;\n    margin-block-start: 0;\n    margin-block-end: 0;\n    padding-inline-start: 0;\n    padding-left: 0;\n  ']);

  var VerticalNavSection = function VerticalNavSection(_ref) {
    var label = _ref.label,
        children = _ref.children,
        className = _ref.className;
    return React.createElement(
      'ul',
      {
        'aria-label': label,
        className: (0, _emotion.cx)(classNames.ulReset, className),
        key: label
      },
      children
    );
  };

  VerticalNavSection.defaultProps = { className: '' };

  var classNames = {
    ulReset: (0, _emotion.css)(_templateObject)
  };

  exports.default = VerticalNavSection;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/VerticalNav/VerticalNavSection.js
// module id = 2034
// module chunks = 1